"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortLabelValues = exports.areEqualCaseInsensitive = exports.compareTextCaseInsensitive = void 0;
const compareTextCaseInsensitive = (a, b) => a.toLowerCase().localeCompare(b.toLowerCase());
exports.compareTextCaseInsensitive = compareTextCaseInsensitive;
const areEqualCaseInsensitive = (a, b) => (0, exports.compareTextCaseInsensitive)(a, b) === 0;
exports.areEqualCaseInsensitive = areEqualCaseInsensitive;
const sortLabelValues = (values, direction) => {
    if (values.length <= 1) {
        return values;
    }
    return [...values].sort((a, b) => {
        const cmp = (0, exports.compareTextCaseInsensitive)(a, b);
        return direction === 0 /* SortDirection.Ascending */ ? cmp : -cmp;
    });
};
exports.sortLabelValues = sortLabelValues;
